import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from '../../../services/overlay.service';
import { ClipboardService } from 'ngx-clipboard';
import { Subscription } from 'rxjs';
import { LineupService } from '../../../services/lineup.service';
import { Lineup } from '../../../interfaces/lineup';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'lineup-details-configuration',
	templateUrl: './lineup-details-configuration.component.html',
	styleUrls: ['./lineup-details-configuration.component.scss'],
})

export class LineupDetailsConfigurationComponent implements OnInit, OnDestroy {

	@Input() lineup: Lineup;
	@Input() form: NgForm;
	@Input() containsSlideshowPlaylist: boolean;

	validEndpoint: boolean;
	hlsPullUrl = '';

	subscriptions = new Subscription();

	constructor(
		public lineupService: LineupService,
		private clipboardService: ClipboardService,
		private overlayService: OverlayService,
		private translate: TranslateService
	) {
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	ngOnInit() {
		this.subscriptions.add(this.lineupService.hlsPushUrlSubject.subscribe((hlsPullUrl) => {
			this.lineup.hlsPullUrl = hlsPullUrl;
		}));
		this.subscriptions.add(this.lineupService.channelStateSubject.subscribe((channelState) => {
			this.lineup.channelState = channelState;
		}));
	}

	onConfigChanged() {
		this.lineup.configChangeRestartNeeded = true;
	}

	copyToClipboard(url: string) {
		this.clipboardService.copyFromContent(url);
		this.overlayService.createToast(this.translate.instant('URL_COPIED_TO_CLIPBOARD'), 'copy');
	}

	checkValidInputs() {
		this.onAudioUrlChange(this.lineup.audiostreamHlsUrl);
		if (this.lineup.hlsMethod === 'push') {
			this.onEndpointChange(this.lineup.hlsEndpoint);
		}
	}

	onMethodChange(method) {
		if (method === 'pull') {
			this.lineupService.checkPollForChanges(this.lineup);
		}
	}

	onEndpointChange(url) {
		this.validEndpoint = this.isValidUrl(url);
		if (!this.validEndpoint && this.form && this.form.form && this.form.form.controls && this.form.form.controls.hlsEndpoint) {
			this.form.form.controls.hlsEndpoint.setErrors({
				'invalid-format': true
			});
		}
	}

	isValidUrl(str: string): boolean {
		let url;

		try {
			url = new URL(str);
		} catch (_) {
			url = false;
		}
		return !!url;
	}

	onAudioUrlChange(url) {
		if (!this.isValidAudioUrl(url) && this.form && this.form.form && this.form.form.controls && this.form.form.controls.audiostreamHlsUrl) {
			this.form.form.controls.audiostreamHlsUrl.setErrors({
				'invalid-format': true
			});
		}
	}

	isValidAudioUrl(str: string): boolean {
		if (!this.containsSlideshowPlaylist && !str) {
			return true;
		}
		return this.isValidUrl(str) && str.startsWith('http') && !!str.match(/\.(m3u8|m3u)([?#].*)?$/i);
	}
}
